import Wrapper from "../components/Wrapper"
import { phone_number, name, email_address } from "../Data";

function BusinessCard() {
    return (
        <div>
            <Wrapper title={ "Business Card" }>
                <div>
                    <h1>Ryan's Upholstery</h1>
                    <h3>Serving all your upholstery needs</h3>
                    <p>Get in touch at <a href={ `mailto:${email_address}` }>{ email_address }</a></p>
                    <p>Give { name } a call at <a href={`tel:${phone_number}`}>{ phone_number }</a></p>
                    <p>Request a <a href="/quote">free quote</a> today</p>
                    <p>See <a href="/photos">photos of Ryan's work</a> on our website</p>
                    <br/><br/>
                </div>
                <img alt="" src="/images/logo.jpg" width="100%" />
            </Wrapper>
        </div>
    );
}

export default BusinessCard;
